<template>
  <div>
    <van-field :value="value" readonly clickable label="票据类型" placeholder="选择票据类型" @click="showPicker = true" />
    <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="columns" show-toolbar @cancel="showPicker = false" @confirm="onConfirm" /></van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

  name: 'UploadTx',

  data() {
    return {
      value: '',
      showPicker: false,
      columns: [],
      id: []
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo', 'currentDate', 'selectedClient'])
  },
  mounted() {
    this.query();
  },
  methods: {

    query() {
      this.id = [];
      this.axios.post('/elecnotes/leisure-type', { token: this.token }).then(res => {
        for (let i = 0; i < res.data.rows.length; i++) {
          this.columns.push(res.data.rows[i].name);
          this.id.push({ ele_type: res.data.rows[i].ele_type, name: res.data.rows[i].name, num: res.data.rows[i].num });
        }
        sessionStorage.setItem('ex', JSON.stringify(this.id));
      });
    },
    onConfirm(value, index) {
      this.value = value;
      this.id[index];
      console.log(this.id[index] + value);
      this.showPicker = false;
      sessionStorage.setItem('ele_type', this.id[index].ele_type);
      sessionStorage.setItem('name', value);
      this.$router.push('/elecnotes/upload-file-tx');
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/elecnotes/upload-tx.vue